import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useState } from 'react';
import { AiTwotoneCamera } from 'react-icons/ai';
import { IUserAvt } from '../../interfaces/components/index.interface';

const UserAvtModal = dynamic(() => import('../modal/UserAvtModal'), {
  ssr: false, //set SSR to false in order to user window object
});

const UserAvt = ({
  imgSrc,
  viewPermission,
  imageModal,
  setImageModal,
}: IUserAvt) => {
  const [userDefaultAvt, setUserDefaultAvt] = useState(imgSrc);

  return (
    <article className="flex items-end justify-center py-3">
      <div className="h-[100px] w-[100px] overflow-hidden rounded-full object-contain">
        <Image
          src={(userDefaultAvt && userDefaultAvt) || '/img/default-avatar.svg'}
          className={'rounded-full object-contain'}
          alt="avatar"
          width={100}
          height={100}
        />
      </div>
      {viewPermission === 'owner' && (
        <button
          onClick={() => setImageModal(true)}
          className="z-[9] -ml-5 flex flex-col rounded-full bg-white p-1 text-lg text-primary"
        >
          <AiTwotoneCamera />
        </button>
      )}
      <UserAvtModal
        toggle={setImageModal}
        isVisible={imageModal}
        handleSetTemp={setUserDefaultAvt}
        oldAvatar={userDefaultAvt}
      />
    </article>
  );
};

export default UserAvt;
